var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary my-2 my-sm-0",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.action($event)}}},[_c('fa-icon',{attrs:{"icon":_vm.icon}}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553bd544","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/Disconnect.vue
// module id = 312
// module chunks = 1